import React from 'react';
import { Row, Col, Input, Button, Popconfirm, Select } from 'antd';
import ImageComponent from '@sharedComponent/image-component';
import SpanComponent from '@sharedComponent/span-component';
import AccountList from '@sharedComponent/bank/account-list';
import { images } from '@assets/img';
import { getMaskAccountNumber } from '@sharedComponent/bank/bank-account-card';
import { PlusCircleOutlined, EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import '../bank-account.scss';
import AddBankAccountModal from './add-bank-account-model';
import Header from '@sharedComponent/header/header';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import GifLoader from '@sharedComponent/gif-loader';

const { Option } = Select;

// const layout = {
// 	labelCol: { span: 24 },
// 	wrapperCol: { span: 24 },
// };

export const BankAccountInfoPresentational = ({
	state,
	bankForm,
	handleBankChange,
	accountValidate,
	routingValidate,
	handleChange,
	formRef,
	deleteBank,
	activateBank,
	handleAddBankChange,
	onFinish,
	userDetails,
	isEditActive,
	setIsEditActive,
	deleteActiveBank,
	updateActiveBank,
	resetActiveAccount,
}) => {
	return (
		<>
			<Header title="Dashboard / Bank Account Information" />

			<Row className="bank_account_card">
				<Col xl={11} lg={24} md={24} sm={24} xs={24}>
					<Col className="bank_user_info_card">
						{state.loading ? (
							<Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
								{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
								<GifLoader />
							</Col>
						) : (
							<Row>
								<Col xl={8} lg={8} md={8} sm={8} xs={8} className="user_img_area">
									<ImageComponent src={(userDetails && userDetails.profileImage) || images.prof2} className="user_img" />
								</Col>
								{bankForm.bankName ? (
									<Col xl={16} lg={16} md={16} sm={16} xs={16} className="user_card_area">
										<Col className="bank_name">{bankForm.bankName}</Col>
										<Col className="user_name">{bankForm.accountType}</Col>
										<Col className="account_number">{getMaskAccountNumber(bankForm.accountNumber)}</Col>
									</Col>
								) : (
									<Col
										xl={16}
										lg={16}
										md={16}
										sm={16}
										xs={16}
										className="user_card_area"
										style={{ fontSize: '20px', color: 'white', alignItems: 'center', paddingRight: '30px' }}>
										No active bank account
									</Col>
								)}
							</Row>
						)}
					</Col>
					<Col className="add_new_bank_account" onClick={() => handleChange('activeModal', true)}>
						{'    '}
						<PlusCircleOutlined /> Add New Bank Account
					</Col>
					<Col className="user_details_area">
						{state.loading ? (
							<Col style={{ display: 'flex', width: '100%', height: '20vh', justifyContent: 'center', alignItems: 'center' }}>
								{/* <LottieComponent width="30%" height="30%" file={LottieFile.Loading} /> */}
								<GifLoader />
							</Col>
						) : (
							<Row style={{ width: '100%', alignItems: 'center' }}>
								<Col className="user_label" xl={8} lg={8} md={24} sm={24} xs={24}>
									Bank Name
								</Col>
								<Col className="user_value" xl={16} lg={16} md={24} sm={24} xs={24}>
									<Input
										disabled={!isEditActive}
										onChange={(e) => handleBankChange('bankName', e.target.value)}
										value={bankForm.bankName}
									/>
								</Col>

								<Col className="user_label" xl={8} lg={8} md={24} sm={24} xs={24}>
									Account Nickname
								</Col>
								<Col className="user_value" xl={16} lg={16} md={24} sm={24} xs={24}>
									<Input
										disabled={!isEditActive}
										onChange={(e) => handleBankChange('accountNickName', e.target.value)}
										value={bankForm.accountNickName}
									/>
								</Col>

								<Col className="user_label" xl={8} lg={8} md={24} sm={24} xs={24}>
									Routing Number
								</Col>
								<Col className="user_value " xl={16} lg={16} md={24} sm={24} xs={24}>
									<Input
										disabled={!isEditActive}
										onChange={(e) => handleBankChange('routingNumber', e.target.value)}
										className="pre_mask"
										prefix={
											<SpanComponent className="eye_path" onClick={() => handleChange('isMaskRouting', !state.isMaskRouting)}>
												{state.isMaskRouting ? <EyeInvisibleOutlined /> : <EyeOutlined />}
											</SpanComponent>
										}
										value={state.isMaskRouting ? getMaskAccountNumber(bankForm.routingNumber) : bankForm.routingNumber}
									/>
								</Col>

								<Col className="user_label" xl={8} lg={8} md={24} sm={24} xs={24}>
									Account Number
								</Col>
								<Col className="user_value" xl={16} lg={16} md={24} sm={24} xs={24}>
									<Input
										disabled={!isEditActive}
										onChange={(e) => handleBankChange('accountNumber', e.target.value)}
										className="pre_mask"
										prefix={
											<SpanComponent className="eye_path" onClick={() => handleChange('isMaskAccount', !state.isMaskAccount)}>
												{state.isMaskAccount ? <EyeInvisibleOutlined /> : <EyeOutlined />}
											</SpanComponent>
										}
										value={state.isMaskAccount ? getMaskAccountNumber(bankForm.accountNumber) : bankForm.accountNumber}
									/>
								</Col>

								<Col className="user_label" xl={8} lg={8} md={24} sm={24} xs={24}>
									Account Type
								</Col>
								<Col className="user_value" xl={16} lg={16} md={24} sm={24} xs={24}>
									<Select
										disabled={!isEditActive}
										onChange={(e) => handleBankChange('accountType', e)}
										value={bankForm.accountType}>
										<Option value="Checking">Checking</Option>
										<Option value="Savings">Savings</Option>
									</Select>
								</Col>
								{bankForm.isActive ? (
									<Col xl={24} lg={24} md={24} sm={24} xs={24} style={{ marginTop: '10px', textAlign: 'center' }}>
										<Row>
											{isEditActive ? (
												<>
													<Col xl={11} lg={11} md={24} sm={24} xs={24}>
														<Button className="bank_cancel_btn" onClick={resetActiveAccount}>
															{/* <CloseOutlined /> */}
															Cancel
														</Button>
													</Col>
													<Col xl={2} lg={2} sm={0} md={0} xs={0}></Col>
													<Col xl={11} lg={11} md={24} sm={24} xs={24}>
														<Button
															className="bank_update_btn"
															loading={state.editBankLoading}
															onClick={updateActiveBank}>
															Update
															{/* <CheckOutlined /> */}
														</Button>
													</Col>
													{/* <Col xl={6} lg={6} md={24} sm={24} xs={24}>
														<Button
															className="bank_delete_btn"
															loading={state.deleteBankLoading}
															onClick={deleteActiveBank}>
															Delete
														</Button>
													</Col> */}
												</>
											) : (
												<>
													<Col xl={11} lg={11} md={24} sm={24} xs={24}>
														<Button className="bank_edit_btn" onClick={() => setIsEditActive(true)}>
															{/* <EditOutlined /> */}
															Edit
														</Button>
													</Col>
													<Col xl={2} lg={2} sm={0} md={0} xs={0}></Col>
													<Col xl={11} lg={11} md={24} sm={24} xs={24}>
														<Popconfirm
															title="Are you sure to delete this bank account?"
															onConfirm={deleteActiveBank}
															okText="Yes"
															cancelText="No">
															<Button className="bank_delete_btn" loading={state.deleteBankLoading}>
																Delete
															</Button>
														</Popconfirm>
													</Col>
												</>
											)}
										</Row>
									</Col>
								) : null}
							</Row>
						)}
					</Col>
				</Col>
				<Col xl={1} lg={0} md={0} sm={0} xs={0} className="center_horizontal">
					<Col className="center_horizontal_line"></Col>
				</Col>
				<Col
					className="inactive_area"
					xl={11}
					lg={24}
					md={24}
					sm={24}
					xs={24}
					style={{ padding: 5, overflowY: 'scroll', maxHeight: '100%', background: '#ffffff' }}>
					<Col className="inactive_account_header">Inactive Accounts</Col>
					<Col style={{ marginTop: '20px' }}>
						{state.loading ? (
							<Col style={{ display: 'flex', height: '20vh', justifyContent: 'center', alignItems: 'center' }}>
								{/* <LottieComponent width="30%" height="30%" file={LottieFile.Loading} /> */}
								<GifLoader />
							</Col>
						) : (
							<AccountList
								state={state}
								handleChange={handleChange}
								deleteBank={deleteBank}
								accountList={state.inactiveAccountList}
								activateBank={activateBank}
							/>
						)}
					</Col>
				</Col>
				<AddBankAccountModal
					state={state}
					formRef={formRef}
					onFinish={onFinish}
					handleChange={handleChange}
					routingValidate={routingValidate}
					accountValidate={accountValidate}
					handleAddBankChange={handleAddBankChange}
					handleBankChange={handleBankChange}
				/>
			</Row>
		</>
	);
};
